import {iconMap} from "../common/images/icons/iconMap.js";

function channelValue(d, channel, suffix = "") {
    const v = d.channels?.find((e) => e.name === channel)?.value;
    return typeof v !== "undefined" ? `${v}${suffix ? " " + suffix : ""}` : "--";
}
function channelValueYN(d, channel) {
    const v = d.channels?.find((e) => e.name === channel)?.value;
    return v === 1 ? "YES" : "NO";
}
function channelTemp(d, channel) {
    const v = d.channels?.find((e) => e.name === channel)?.value;
    if (typeof v === "undefined") return "--";
    return `${v} °C | ${((v * 9) / 5 + 32).toFixed(0)} °F`;
}
function channelFaultYN(d, faultName) {
    const f = d.channels?.find((e) => e.name === "fault")?.fault;
    return f && f[faultName] ? "YES" : "NO";
}
function channelSysStateYN(d, sysName) {
    const s = d.channels?.find((e) => e.name === "sys_state")?.sys_state;
    if (typeof s === "object" && s !== null && sysName in s) {
        return s[sysName] ? "YES" : "NO";
    }
    return "--";
}

export const deviceFieldConfig = {
    tortoise: [
        {
            label: "Movement Detected",
            value: (d) => (d.iot_summary_payload?.movement_detect_b === 1 ? "YES" : "NO"),
            icon: iconMap.movement_detected_icon,
            color: (d) => (d.iot_summary_payload?.movement_detect_b === 1 ? "red" : "gray")
        },
        {
            label: "GPS Lock Alert",
            value: (d) => (d.iot_summary_payload?.gps_lock_b === 1 ? "YES" : "NO"),
            icon: iconMap.location_pin,
            color: (d) => (d.iot_summary_payload?.gps_lock_b === 1 ? "gray" : "red")
        },
        {
            label: "GPS Used Alert",
            value: (d) => (d.iot_summary_payload?.gps_used_b === 1 ? "YES" : "NO"),
            icon: iconMap.location_pin,
            color: (d) => (d.iot_summary_payload?.gps_used_b === 1 ? "gray" : "red")
        },
        {
            label: "Cn OK Alert",
            value: (d) => (d.iot_summary_payload?.cno_ok_b === 1 ? "YES" : "NO"),
            icon: iconMap.location_pin,
            color: (d) => (d.iot_summary_payload?.cno_ok_b === 1 ? "gray" : "red")
        },
        {
            label: "GPS Signal Strength",
            value: (d) => (d.iot_summary_payload?.hdop ?? "") + " hdop",
            icon: iconMap.location_pin 
        },
        {
            label: "Battery Level",
            value: (d) => (isNaN(d.iot_summary_payload?.battery_level) || d.iot_summary_payload?.battery_level < 0 ? "0 %" : `${Math.min(100, d.iot_summary_payload?.battery_level)} %`),
            icon: (d) => {
                const level = d.iot_summary_payload?.battery_level ?? 0;
                if (level <= 10) return iconMap.battery0_10;
                if (level <= 20) return iconMap.battery11_20;
                if (level <= 40) return iconMap.battery21_40;
                if (level <= 60) return iconMap.battery41_60;
                if (level <= 80) return iconMap.battery61_80;
                return iconMap.battery81_100;
            }
        },
        {
            label: "Connectivity",
            value: (d) => {
                const lq = d.iot_summary_payload?.link_quality;
                if (lq === 0) return "Bad";
                if (lq === 1) return "Average";
                if (lq === 2) return "Good";
                if (lq === 3 || lq === 4) return "Excellent";
                return "--";
            },
            icon: (mode, d) => {
                const lq = d.iot_summary_payload?.link_quality ?? 0;
                if (lq === 0) return mode === "dark" ? iconMap.signalbad_Dark : iconMap.signalbad_Light;
                if (lq === 1) return mode === "dark" ? iconMap.signalaverage_Dark : iconMap.signalaverage_Light;
                if (lq === 2) return mode === "dark" ? iconMap.signalgood_Dark : iconMap.signalgood_Light;
                if (lq === 3 || lq === 4) return mode === "dark" ? iconMap.signalexcellent_Dark : iconMap.signalexcellent_Light;
                return mode === "dark" ? iconMap.signalnone_Dark : iconMap.signalnone_Light;
            }
        }
    ],

    nngen2_leak: [
        {
            label: "Detection",
            value: (d) => (d.iot_summary_payload?.liquid_detect_b === 0 ? "DRY" : "WET"),
            icon: (d) => (d.iot_summary_payload?.liquid_detect_b === 0 ? iconMap.dropdry : iconMap.dropwet)
        },
        {
            label: "Battery Voltage",
            value: (d) => `${((d.iot_summary_payload?.battery_voltage ?? 0) / 1000).toFixed(2)} V`,
            icon: (d) => {
                const level = (d.iot_summary_payload?.battery_voltage ?? 0) / 10;
                if (level <= 10) return iconMap.battery0_10;
                if (level <= 20) return iconMap.battery11_20;
                if (level <= 40) return iconMap.battery21_40;
                if (level <= 60) return iconMap.battery41_60;
                if (level <= 80) return iconMap.battery61_80;
                return iconMap.battery81_100;
            }
        },
        {
            label: "Connectivity",
            value: (d) => {
                const lq = d.iot_summary_payload?.link_quality;
                if (lq === 0) return "Bad";
                if (lq === 1) return "Average";
                if (lq === 2) return "Good";
                if (lq === 3 || lq === 4) return "Excellent";
                return "--";
            },
            icon: (mode, d) => {
                const lq = d.iot_summary_payload?.link_quality ?? 0;
                if (lq === 0) return mode === "dark" ? iconMap.signalbad_Dark : iconMap.signalbad_Light;
                if (lq === 1) return mode === "dark" ? iconMap.signalaverage_Dark : iconMap.signalaverage_Light;
                if (lq === 2) return mode === "dark" ? iconMap.signalgood_Dark : iconMap.signalgood_Light;
                if (lq === 3 || lq === 4) return mode === "dark" ? iconMap.signalexcellent_Dark : iconMap.signalexcellent_Light;
                return mode === "dark" ? iconMap.signalnone_Dark : iconMap.signalnone_Light;
            }
        }
    ],

    nngen2_flood: [
        {
            label: "Detection",
            value: (d) => (d.iot_summary_payload?.liquid_detect_b === 0 ? "DRY" : "WET"),
            icon: (d) => (d.iot_summary_payload?.liquid_detect_b === 0 ? iconMap.dropdry : iconMap.dropwet)
        },
        {
            label: "Battery Voltage",
            value: (d) => `${((d.iot_summary_payload?.battery_voltage ?? 0) / 1000).toFixed(2)} V`,
            icon: (d) => {
                const level = (d.iot_summary_payload?.battery_voltage ?? 0) / 10;
                if (level <= 10) return iconMap.battery0_10;
                if (level <= 20) return iconMap.battery11_20;
                if (level <= 40) return iconMap.battery21_40;
                if (level <= 60) return iconMap.battery41_60;
                if (level <= 80) return iconMap.battery61_80;
                return iconMap.battery81_100;
            }
        },
        {
            label: "Connectivity",
            value: (d) => {
                const lq = d.iot_summary_payload?.link_quality;
                if (lq === 0) return "Bad";
                if (lq === 1) return "Average";
                if (lq === 2) return "Good";
                if (lq === 3 || lq === 4) return "Excellent";
                return "--";
            },
            icon: (mode, d) => {
                const lq = d.iot_summary_payload?.link_quality ?? 0;
                if (lq === 0) return mode === "dark" ? iconMap.signalbad_Dark : iconMap.signalbad_Light;
                if (lq === 1) return mode === "dark" ? iconMap.signalaverage_Dark : iconMap.signalaverage_Light;
                if (lq === 2) return mode === "dark" ? iconMap.signalgood_Dark : iconMap.signalgood_Light;
                if (lq === 3 || lq === 4) return mode === "dark" ? iconMap.signalexcellent_Dark : iconMap.signalexcellent_Light;
                return mode === "dark" ? iconMap.signalnone_Dark : iconMap.signalnone_Light;
            }
        }
    ],

    nngen2_temperature: [
        {
            label: "Temperature",
            value: (d) =>
                `Probe: ${d.iot_summary_payload?.external_temperature?.toFixed(2) ?? "--"} °C | ${(((d.iot_summary_payload?.external_temperature ?? 0) * 9) / 5 + 32).toFixed(2)} °F
        \nAmbient: ${d.iot_summary_payload?.internal_temperature?.toFixed(2) ?? "--"} °C | ${(((d.iot_summary_payload?.internal_temperature ?? 0) * 9) / 5 + 32).toFixed(2)} °F`,
            icon: iconMap.temperature
        },
        {
            label: "Battery Voltage",
            value: (d) => `${((d.iot_summary_payload?.battery_voltage ?? 0) / 1000).toFixed(2)} V`,
            icon: (d) => {
                const level = (d.iot_summary_payload?.battery_voltage ?? 0) / 10;
                if (level <= 10) return iconMap.battery0_10;
                if (level <= 20) return iconMap.battery11_20;
                if (level <= 40) return iconMap.battery21_40;
                if (level <= 60) return iconMap.battery41_60;
                if (level <= 80) return iconMap.battery61_80;
                return iconMap.battery81_100;
            }
        },
        {
            label: "Connectivity",
            value: (d) => {
                const lq = d.iot_summary_payload?.link_quality;
                if (lq === 0) return "Bad";
                if (lq === 1) return "Average";
                if (lq === 2) return "Good";
                if (lq === 3 || lq === 4) return "Excellent";
                return "--";
            },
            icon: (mode, d) => {
                const lq = d.iot_summary_payload?.link_quality ?? 0;
                if (lq === 0) return mode === "dark" ? iconMap.signalbad_Dark : iconMap.signalbad_Light;
                if (lq === 1) return mode === "dark" ? iconMap.signalaverage_Dark : iconMap.signalaverage_Light;
                if (lq === 2) return mode === "dark" ? iconMap.signalgood_Dark : iconMap.signalgood_Light;
                if (lq === 3 || lq === 4) return mode === "dark" ? iconMap.signalexcellent_Dark : iconMap.signalexcellent_Light;
                return mode === "dark" ? iconMap.signalnone_Dark : iconMap.signalnone_Light;
            }
        }
    ],

    nngen2_temp: [
        {
            label: "Temperature",
            value: (d) =>
                `Probe: ${d.iot_summary_payload?.external_temperature?.toFixed(2) ?? "--"} °C | ${(((d.iot_summary_payload?.external_temperature ?? 0) * 9) / 5 + 32).toFixed(2)} °F
        \nAmbient: ${d.iot_summary_payload?.internal_temperature?.toFixed(2) ?? "--"} °C | ${(((d.iot_summary_payload?.internal_temperature ?? 0) * 9) / 5 + 32).toFixed(2)} °F`,
            icon: iconMap.temperature
        },
        {
            label: "Battery Voltage",
            value: (d) => `${((d.iot_summary_payload?.battery_voltage ?? 0) / 1000).toFixed(2)} V`,
            icon: (d) => {
                const level = (d.iot_summary_payload?.battery_voltage ?? 0) / 10;
                if (level <= 10) return iconMap.battery0_10;
                if (level <= 20) return iconMap.battery11_20;
                if (level <= 40) return iconMap.battery21_40;
                if (level <= 60) return iconMap.battery41_60;
                if (level <= 80) return iconMap.battery61_80;
                return iconMap.battery81_100;
            }
        },
        {
            label: "Connectivity",
            value: (d) => {
                const lq = d.iot_summary_payload?.link_quality;
                if (lq === 0) return "Bad";
                if (lq === 1) return "Average";
                if (lq === 2) return "Good";
                if (lq === 3 || lq === 4) return "Excellent";
                return "--";
            },
            icon: (mode, d) => {
                const lq = d.iot_summary_payload?.link_quality ?? 0;
                if (lq === 0) return mode === "dark" ? iconMap.signalbad_Dark : iconMap.signalbad_Light;
                if (lq === 1) return mode === "dark" ? iconMap.signalaverage_Dark : iconMap.signalaverage_Light;
                if (lq === 2) return mode === "dark" ? iconMap.signalgood_Dark : iconMap.signalgood_Light;
                if (lq === 3 || lq === 4) return mode === "dark" ? iconMap.signalexcellent_Dark : iconMap.signalexcellent_Light;
                return mode === "dark" ? iconMap.signalnone_Dark : iconMap.signalnone_Light;
            }
        }
    ],

    nngen2_tempvibe: [
        {
            label: "Temperature",
            value: (d) =>
                `Probe: ${(d.iot_summary_payload?.external_temperature / 100)?.toFixed(2) ?? "--"} °C | ${(((d.iot_summary_payload?.external_temperature ?? 0) * 9) / 5 + 32 / 100).toFixed(2)} °F
        \nAmbient: ${d.iot_summary_payload?.internal_temperature?.toFixed(2) ?? "--"} °C | ${(((d.iot_summary_payload?.internal_temperature ?? 0) * 9) / 5 + 32).toFixed(2)} °F`,
            icon: iconMap.temperature
        },
        {
            label: "Movement Detected",
            value: (d) => (d.iot_summary_payload?.movement_detect_b === 1 ? "YES" : "NO"),
            icon: iconMap.movement_detected_icon,
            color: (d) => (d.iot_summary_payload?.movement_detect_b === 1 ? "red" : "gray")
        },
        {
            label: "Battery Voltage",
            value: (d) => `${((d.iot_summary_payload?.battery_voltage ?? 0) / 1000).toFixed(2)} V`,
            icon: (d) => {
                const level = (d.iot_summary_payload?.battery_voltage ?? 0) / 10;
                if (level <= 10) return iconMap.battery0_10;
                if (level <= 20) return iconMap.battery11_20;
                if (level <= 40) return iconMap.battery21_40;
                if (level <= 60) return iconMap.battery41_60;
                if (level <= 80) return iconMap.battery61_80;
                return iconMap.battery81_100;
            }
        },
        {
            label: "Connectivity",
            value: (d) => {
                const lq = d.iot_summary_payload?.link_quality;
                if (lq === 0) return "Bad";
                if (lq === 1) return "Average";
                if (lq === 2) return "Good";
                if (lq === 3 || lq === 4) return "Excellent";
                return "--";
            },
            icon: (mode, d) => {
                const lq = d.iot_summary_payload?.link_quality ?? 0;
                if (lq === 0) return mode === "dark" ? iconMap.signalbad_Dark : iconMap.signalbad_Light;
                if (lq === 1) return mode === "dark" ? iconMap.signalaverage_Dark : iconMap.signalaverage_Light;
                if (lq === 2) return mode === "dark" ? iconMap.signalgood_Dark : iconMap.signalgood_Light;
                if (lq === 3 || lq === 4) return mode === "dark" ? iconMap.signalexcellent_Dark : iconMap.signalexcellent_Light;
                return mode === "dark" ? iconMap.signalnone_Dark : iconMap.signalnone_Light;
            }
        }
    ],

    nngen2_level: [
        {
            label: "Volume",
            value: (d) => {
                const h = d.iot_summary_payload?.level_reading_at_present > 5000 ? 15000 : 5000;
                const pct = (((h - (d.iot_summary_payload?.level_reading_at_present ?? 0)) / h) * 100).toFixed(2);
                return `${pct} % | ${d.iot_summary_payload?.level_reading_at_present} mm from top`;
            },
            icon: iconMap.volume,
            tankHeight: (d) => (d.iot_summary_payload?.level_reading_at_present > 5000 ? 15000 : 5000)
        },
        {
            label: "Battery Voltage",
            value: (d) => `${((d.iot_summary_payload?.battery_voltage ?? 0) / 1000).toFixed(2)} V`,
            icon: (d) => {
                const level = (d.iot_summary_payload?.battery_voltage ?? 0) / 10;
                if (level <= 10) return iconMap.battery0_10;
                if (level <= 20) return iconMap.battery11_20;
                if (level <= 40) return iconMap.battery21_40;
                if (level <= 60) return iconMap.battery41_60;
                if (level <= 80) return iconMap.battery61_80;
                return iconMap.battery81_100;
            }
        },
        {
            label: "Connectivity",
            value: (d) => {
                const lq = d.iot_summary_payload?.link_quality;
                if (lq === 0) return "Bad";
                if (lq === 1) return "Average";
                if (lq === 2) return "Good";
                if (lq === 3 || lq === 4) return "Excellent";
                return "--";
            },
            icon: (mode, d) => {
                const lq = d.iot_summary_payload?.link_quality ?? 0;
                if (lq === 0) return mode === "dark" ? iconMap.signalbad_Dark : iconMap.signalbad_Light;
                if (lq === 1) return mode === "dark" ? iconMap.signalaverage_Dark : iconMap.signalaverage_Light;
                if (lq === 2) return mode === "dark" ? iconMap.signalgood_Dark : iconMap.signalgood_Light;
                if (lq === 3 || lq === 4) return mode === "dark" ? iconMap.signalexcellent_Dark : iconMap.signalexcellent_Light;
                return mode === "dark" ? iconMap.signalnone_Dark : iconMap.signalnone_Light;
            }
        }
    ],

    nngen2_flow: [
        {
            label: "Liters per Hour",
            value: (d) => `${d.iot_summary_payload?.volume_since_last_tx} L/h`,
            icon: iconMap.volume
        },
        {
            label: "Battery Voltage",
            value: (d) => `${((d.iot_summary_payload?.battery_voltage ?? 0) / 1000).toFixed(2)} V`,
            icon: (d) => {
                const level = (d.iot_summary_payload?.battery_voltage ?? 0) / 10;
                if (level <= 10) return iconMap.battery0_10;
                if (level <= 20) return iconMap.battery11_20;
                if (level <= 40) return iconMap.battery21_40;
                if (level <= 60) return iconMap.battery41_60;
                if (level <= 80) return iconMap.battery61_80;
                return iconMap.battery81_100;
            }
        },
        {
            label: "Connectivity",
            value: (d) => {
                const lq = d.iot_summary_payload?.link_quality;
                if (lq === 0) return "Bad";
                if (lq === 1) return "Average";
                if (lq === 2) return "Good";
                if (lq === 3 || lq === 4) return "Excellent";
                return "--";
            },
            icon: (mode, d) => {
                const lq = d.iot_summary_payload?.link_quality ?? 0;
                if (lq === 0) return mode === "dark" ? iconMap.signalbad_Dark : iconMap.signalbad_Light;
                if (lq === 1) return mode === "dark" ? iconMap.signalaverage_Dark : iconMap.signalaverage_Light;
                if (lq === 2) return mode === "dark" ? iconMap.signalgood_Dark : iconMap.signalgood_Light;
                if (lq === 3 || lq === 4) return mode === "dark" ? iconMap.signalexcellent_Dark : iconMap.signalexcellent_Light;
                return mode === "dark" ? iconMap.signalnone_Dark : iconMap.signalnone_Light;
            }
        }
    ],

    nngen2_ble_soap1: [
        {
            label: "Battery Level",
            value: (d) => {
                const bl = d.channels?.find((e) => e.name === "battery_low")?.value === 0 ? "Good" : "Bad";
                return bl;
            },
            icon: (d) => (d.channels?.find((e) => e.name === "battery_low")?.value === 0 ? iconMap.battery81_100 : iconMap.battery11_20)
        },
        {
            label: "Remaining",
            value: (d) => {
                const mmMin = d.mmMin ?? 0,
                    mmMax = d.mmMax ?? 100;
                let v = d.channels?.find((e) => e.name === "value")?.value;
                let pct = ((1.0 - (v - mmMin) / (mmMax - mmMin)) * 100).toFixed(2);
                pct = Math.min(100, Math.max(0, pct));
                return pct + "%";
            },
            icon: iconMap.percentage
        },
        {
            label: "Connectivity",
            value: (d) => (d.channels?.find((e) => e.name === "is_visible")?.value === 1 ? "Good" : "Bad"),
            icon: (d) => (d.channels?.find((e) => e.name === "is_visible")?.value === 1 ? iconMap.signalexcellent_Light : iconMap.signalbad_Light)
        },
        {
            type: "image",
            getSrc: (d) => {
                const v = d.channels?.find((e) => e.name === "value")?.value ?? 0;
                if (v <= 25) return iconMap.soap_dispenser_red;
                if (v <= 50) return iconMap.soap_dispenser_orange;
                if (v <= 75) return iconMap.soap_dispenser_yellow;
                return iconMap.soap_dispenser_green;
            }
        }
    ],

    nngen2_ble_jumbo_s: [
        {
            label: "Battery Level",
            value: (d) => {
                const bl = d.channels?.find((e) => e.name === "battery_low")?.value === 0 ? "Good" : "Bad";
                return bl;
            },
            icon: (d) => (d.channels?.find((e) => e.name === "battery_low")?.value === 0 ? iconMap.battery81_100 : iconMap.battery11_20)
        },
        {
            label: "Remaining",
            value: (d) => {
                const mmMin = d.mmMin ?? 0,
                    mmMax = d.mmMax ?? 100;
                let v = d.channels?.find((e) => e.name === "value")?.value;
                let pct = ((1.0 - (v - mmMin) / (mmMax - mmMin)) * 100).toFixed(2);
                pct = Math.min(100, Math.max(0, pct));
                return pct + "%";
            },
            icon: iconMap.percentage
        },
        {
            label: "Connectivity",
            value: (d) => (d.channels?.find((e) => e.name === "is_visible")?.value === 1 ? "Good" : "Bad"),
            icon: (d) => (d.channels?.find((e) => e.name === "is_visible")?.value === 1 ? iconMap.signalexcellent_Light : iconMap.signalbad_Light)
        },
        {
            type: "image",
            getSrc: (d) => {
                const v = d.channels?.find((e) => e.name === "value")?.value ?? 0;
                if (v <= 25) return iconMap.soap_roll_dispenser_red;
                if (v <= 50) return iconMap.soap_roll_dispenser_orange;
                if (v <= 75) return iconMap.soap_roll_dispenser_yellow;
                return iconMap.soap_roll_dispenser_green;
            }
        }
    ],

    nngen2_ble_jumbo_l: [
        {
            label: "Battery Level",
            value: (d) => {
                const bl = d.channels?.find((e) => e.name === "battery_low")?.value === 0 ? "Good" : "Bad";
                return bl;
            },
            icon: (d) => (d.channels?.find((e) => e.name === "battery_low")?.value === 0 ? iconMap.battery81_100 : iconMap.battery11_20)
        },
        {
            label: "Remaining",
            value: (d) => {
                const mmMin = d.mmMin ?? 0,
                    mmMax = d.mmMax ?? 100;
                let v = d.channels?.find((e) => e.name === "value")?.value;
                let pct = ((1.0 - (v - mmMin) / (mmMax - mmMin)) * 100).toFixed(2);
                pct = Math.min(100, Math.max(0, pct));
                return pct + "%";
            },
            icon: iconMap.percentage
        },
        {
            label: "Connectivity",
            value: (d) => (d.channels?.find((e) => e.name === "is_visible")?.value === 1 ? "Good" : "Bad"),
            icon: (d) => (d.channels?.find((e) => e.name === "is_visible")?.value === 1 ? iconMap.signalexcellent_Light : iconMap.signalbad_Light)
        },
        {
            type: "image",
            getSrc: (d) => {
                const v = d.channels?.find((e) => e.name === "value")?.value ?? 0;
                if (v <= 25) return iconMap.soap_roll_dispenser_red;
                if (v <= 50) return iconMap.soap_roll_dispenser_orange;
                if (v <= 75) return iconMap.soap_roll_dispenser_yellow;
                return iconMap.soap_roll_dispenser_green;
            }
        }
    ],

    nngen2_ble_flat_sheet: [
        {
            label: "Battery Level",
            value: (d) => {
                const bl = d.channels?.find((e) => e.name === "battery_low")?.value === 0 ? "Good" : "Bad";
                return bl;
            },
            icon: (d) => (d.channels?.find((e) => e.name === "battery_low")?.value === 0 ? iconMap.battery81_100 : iconMap.battery11_20)
        },
        {
            label: "Remaining",
            value: (d) => {
                const mmMin = d.mmMin ?? 0,
                    mmMax = d.mmMax ?? 100;
                let v = d.channels?.find((e) => e.name === "value")?.value;
                let pct = ((1.0 - (v - mmMin) / (mmMax - mmMin)) * 100).toFixed(2);
                pct = Math.min(100, Math.max(0, pct));
                return pct + "%";
            },
            icon: iconMap.percentage
        },
        {
            label: "Connectivity",
            value: (d) => (d.channels?.find((e) => e.name === "is_visible")?.value === 1 ? "Good" : "Bad"),
            icon: (d) => (d.channels?.find((e) => e.name === "is_visible")?.value === 1 ? iconMap.signalexcellent_Light : iconMap.signalbad_Light)
        },
        {
            type: "image",
            getSrc: (d) => {
                const v = d.channels?.find((e) => e.name === "value")?.value ?? 0;
                if (v <= 25) return iconMap.flat_sheet_red;
                if (v <= 50) return iconMap.flat_sheet_orange;
                if (v <= 75) return iconMap.flat_sheet_yellow;
                return iconMap.flat_sheet_green;
            }
        }
    ],

    nngen2_people_counter1: [
        {
            label: "Total In",
            value: (d) => d.channels?.find((e) => e.name === "total_in")?.value,
            icon: iconMap.stats_in
        },
        {
            label: "Total In (Last 5 Min)",
            value: (d) => d.channels?.find((e) => e.name === "period_in")?.value,
            icon: iconMap.stats_in
        },
        {
            label: "Battery Level",
            value: (d) => `${Math.min(100, Math.max(0, d.channels?.find((e) => e.name === "battery_level")?.value ?? 0))}%`,
            icon: (d) => {
                const level = d.channels?.find((e) => e.name === "battery_level")?.value ?? 0;
                if (level <= 10) return iconMap.battery0_10;
                if (level <= 20) return iconMap.battery11_20;
                if (level <= 40) return iconMap.battery21_40;
                if (level <= 60) return iconMap.battery41_60;
                if (level <= 80) return iconMap.battery61_80;
                return iconMap.battery81_100;
            }
        },
        {
            label: "Connectivity",
            value: (d) => `${d.channels?.find((e) => e.name === "rssi")?.value} dBm`,
            icon: iconMap.signalexcellent_Light
        }
    ],

    moda_aqs1: [
        {label: "Board Health", value: (d) => channelValueYN(d, "brd_health"), icon: iconMap.brd_health},
        {label: "GPS Lock", value: (d) => channelValueYN(d, "gps_lock"), icon: iconMap.gps_lock},
        {label: "MCU Temperature", value: (d) => channelTemp(d, "mcu_temp"), icon: iconMap.temperature},
        {label: "VSD Setting Pressure", value: (d) => channelValue(d, "setting_pressure"), icon: iconMap.setting_pressure},
        {label: "VSD Outlet Pressure", value: (d) => channelValue(d, "outlet_pressure"), icon: iconMap.outlet_pressure},
        {label: "VSD Pump 1 Frequency", value: (d) => channelValue(d, "pump1_freq", "Hz"), icon: iconMap.pump_freq},
        {label: "VSD Pump 1 Power", value: (d) => channelValue(d, "pump1_power"), icon: iconMap.pump_power},
        {label: "System Operation", value: (d) => channelFaultYN(d, "system_operation"), icon: iconMap.vsd_fault},
        {label: "System Stop", value: (d) => channelFaultYN(d, "system_stop"), icon: iconMap.vsd_fault},
        {label: "System Fault", value: (d) => channelFaultYN(d, "system_fault"), icon: iconMap.vsd_fault},
        {label: "System Lack of Water", value: (d) => channelFaultYN(d, "system_lack_of_water"), icon: iconMap.vsd_fault},
        {label: "External Lack of Water", value: (d) => channelFaultYN(d, "external_lack_of_water"), icon: iconMap.vsd_fault},
        {label: "Low Water Level", value: (d) => channelFaultYN(d, "low_water_level"), icon: iconMap.vsd_fault},
        {label: "High Water Level", value: (d) => channelFaultYN(d, "high_water_level"), icon: iconMap.vsd_fault},
        {label: "External Low Water Level", value: (d) => channelFaultYN(d, "external_low_water_level"), icon: iconMap.vsd_fault},
        {label: "External High Water Level", value: (d) => channelFaultYN(d, "external_high_water_level"), icon: iconMap.vsd_fault},
        {label: "1st as master VFD", value: (d) => channelSysStateYN(d, "master_vfd_1"), icon: iconMap.vsd_state},
        {label: "Pump 1 Run", value: (d) => channelSysStateYN(d, "pump_1_run"), icon: iconMap.vsd_state},
        {label: "Transmitter 1 Normal", value: (d) => channelSysStateYN(d, "transmitter_1_normal"), icon: iconMap.vsd_state}
    ],

    nngen2_ble_reader: [],

    nngen2_ble_jumbo_twin_left: [
        {
            label: "Battery Level",
            value: (d) => (d.channels?.find((e) => e.name === "battery_low")?.value === 0 ? "Good" : "Bad"),
            icon: (d) => (d.channels?.find((e) => e.name === "battery_low")?.value === 0 ? iconMap.battery81_100 : iconMap.battery11_20)
        },
        {
            label: "Remaining",
            value: (d) => {
                const mmMin = d.mmMin ?? 0,
                    mmMax = d.mmMax ?? 100;
                let v = d.channels?.find((e) => e.name === "value")?.value;
                let pct = ((1.0 - (v - mmMin) / (mmMax - mmMin)) * 100).toFixed(2);
                pct = Math.min(100, Math.max(0, pct));
                return pct + "%";
            },
            icon: iconMap.percentage
        },
        {
            label: "Connectivity",
            value: (d) => (d.channels?.find((e) => e.name === "is_visible")?.value === 1 ? "Good" : "Bad"),
            icon: (d) => (d.channels?.find((e) => e.name === "is_visible")?.value === 1 ? iconMap.signalexcellent_Light : iconMap.signalbad_Light)
        },
        {
            type: "image",
            getSrc: (d) => {
                const v = d.channels?.find((e) => e.name === "value")?.value ?? 0;
                if (v <= 25) return iconMap.soap_roll_dispenser_red;
                if (v <= 50) return iconMap.soap_roll_dispenser_orange;
                if (v <= 75) return iconMap.soap_roll_dispenser_yellow;
                return iconMap.soap_roll_dispenser_green;
            }
        }
    ],

    nngen2_ble_jumbo_twin_right: [
        {
            label: "Battery Level",
            value: (d) => (d.channels?.find((e) => e.name === "battery_low")?.value === 0 ? "Good" : "Bad"),
            icon: (d) => (d.channels?.find((e) => e.name === "battery_low")?.value === 0 ? iconMap.battery81_100 : iconMap.battery11_20)
        },
        {
            label: "Remaining",
            value: (d) => {
                const mmMin = d.mmMin ?? 0,
                    mmMax = d.mmMax ?? 100;
                let v = d.channels?.find((e) => e.name === "value")?.value;
                let pct = ((1.0 - (v - mmMin) / (mmMax - mmMin)) * 100).toFixed(2);
                pct = Math.min(100, Math.max(0, pct));
                return pct + "%";
            },
            icon: iconMap.percentage
        },
        {
            label: "Connectivity",
            value: (d) => (d.channels?.find((e) => e.name === "is_visible")?.value === 1 ? "Good" : "Bad"),
            icon: (d) => (d.channels?.find((e) => e.name === "is_visible")?.value === 1 ? iconMap.signalexcellent_Light : iconMap.signalbad_Light)
        },
        {
            type: "image",
            getSrc: (d) => {
                const v = d.channels?.find((e) => e.name === "value")?.value ?? 0;
                if (v <= 25) return iconMap.soap_roll_dispenser_red;
                if (v <= 50) return iconMap.soap_roll_dispenser_orange;
                if (v <= 75) return iconMap.soap_roll_dispenser_yellow;
                return iconMap.soap_roll_dispenser_green;
            }
        }
    ],

    default: [
        {
            label: "Battery Voltage",
            value: (d) => `${((d.iot_summary_payload?.battery_voltage ?? 0) / 1000).toFixed(2)} V`,
            icon: (d) => {
                const level = (d.iot_summary_payload?.battery_voltage ?? 0) / 10;
                if (level <= 10) return iconMap.battery0_10;
                if (level <= 20) return iconMap.battery11_20;
                if (level <= 40) return iconMap.battery21_40;
                if (level <= 60) return iconMap.battery41_60;
                if (level <= 80) return iconMap.battery61_80;
                return iconMap.battery81_100;
            }
        },
        {
            label: "Connectivity",
            value: (d) => {
                const lq = d.iot_summary_payload?.link_quality;
                if (lq === 0) return "Bad";
                if (lq === 1) return "Average";
                if (lq === 2) return "Good";
                if (lq === 3 || lq === 4) return "Excellent";
                return "--";
            },
            icon: (mode, d) => {
                const lq = d.iot_summary_payload?.link_quality ?? 0;
                if (lq === 0) return mode === "dark" ? iconMap.signalbad_Dark : iconMap.signalbad_Light;
                if (lq === 1) return mode === "dark" ? iconMap.signalaverage_Dark : iconMap.signalaverage_Light;
                if (lq === 2) return mode === "dark" ? iconMap.signalgood_Dark : iconMap.signalgood_Light;
                if (lq === 3 || lq === 4) return mode === "dark" ? iconMap.signalexcellent_Dark : iconMap.signalexcellent_Light;
                return mode === "dark" ? iconMap.signalnone_Dark : iconMap.signalnone_Light;
            }
        }
    ]
};
